import { Subject, Observable } from 'rxjs/Rx';

export class Notification {
    private static notificationSubject: Subject<boolean> = new Subject<boolean>();

    public static notificationSubscriber: Observable<boolean>;

    private static refreshSubject: Subject<boolean> = new Subject<boolean>();

    public static refreshSubscriber: Observable<boolean>;

    static init(){
        Notification.notificationSubscriber = Notification.notificationSubject.asObservable();
        Notification.refreshSubscriber = Notification.refreshSubject.asObservable();
    }

    static broadcast(){
        Notification.notificationSubject.next(true);
    }
    
    static refreshOnSubmit(value:boolean){
        Notification.refreshSubject.next(value);
    }
}



// WEBPACK FOOTER //
// ./src/app/domain/notification-broadcaster.ts